import * as React from 'react';
import { Checkbox } from '@highereducation/hen-ui';
import { fieldName, subInputName } from '../submit';
import {
  FieldLegend,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/**
 * CHECKBOX field — one hen-ui `Checkbox` per choice. Each carries its GF
 * sub-input id in the name (`input_{formId}_{inputId}`) so the submit builder
 * can assemble `checkboxValues: [{ inputId, value }]`. hen-ui `Checkbox` renders
 * a hidden native input that posts `name=value` only when checked.
 */
export function CheckboxField({ field, formId, error }: FieldComponentProps) {
  const choices = field.choices ?? [];
  const inputs = field.inputs ?? [];
  const groupName = fieldName(formId, field.id);

  return (
    <>
      <fieldset className='flex flex-col gap-xxs border-0 p-0'>
        <FieldLegend field={field} />
        {choices.map((choice, index) => {
          const inputId = inputs[index]?.id ?? `${field.id}.${index + 1}`;
          const name = subInputName(formId, inputId);
          const optionId = `${groupName}-${index}`;
          return (
            <Checkbox
              key={choice.value}
              id={optionId}
              name={name}
              value={choice.value}
              label={choice.text}
              error={Boolean(error)}
            />
          );
        })}
      </fieldset>
      <FieldErrorMessage error={error} />
    </>
  );
}
